



















































































































































































































































































































































































































































































































import Vue from "vue";
import tenantService from "@/services/tenantService";

export default Vue.extend({
  name: "PresentationStandalone",
  computed: {
    isMainTenant(): boolean {
      return tenantService.isMainTenant();
    },
  },
});
